export default "__VITE_ASSET__42c1dac5__"